export const currentDataList = [
  {
    'key': 'FL_INV',
    'value': 'FL_INV',
    'text': 'INVENTARIO FLOTANTE',
  },
  {
    'key': 'FL_CLI',
    'value': 'FL_CLI',
    'text': 'CLIENTES FLOTANTES',
  },
];
